//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from "@/request/index";
import { getUrlparams } from "@/utils/util.js";
import footerNav from "@/components/footerNav";
import { uploadFile } from "@/utils/auth";
import { Dialog, Toast, ImagePreview } from "vant";
import homeTip from "@/components/homeTip";

export default {
  name: "followOrderDetail",
  components: {
    footerNav,
    homeTip
  },
  data() {
    return {
      sendOrderId: "",
      fileList: [],
      orderPosition: "",
      basicForm: {
        sendOrderDetailList: [],
        productSkuList: [],
        imgList: [],
        purchaseOrderSn: "",
        firstDeptName: "",
        secondDeptName: "",
        supplierName: "",
        sendType: "",
        driverName: "",
        driverPhone: "",
        expressNo: "",
        expressId: "",
        orderPosition: "",
        remark: "",
        sendTime: "",
        sendOrderSn: "",
        deliveryOrderSn: "",
        crtTime: "",
        channelStr: "",
        storeName: "",
        sendOrderStatusName: "",
        confirmFile: [],
        spuCode: "",
        colorValue: "",
        pageType: 1,
        remark: "",
        qualityOrderTypeStr: "",
        reciveTotalCtn: "",
        crtUserName: ""
      },
      canSubmit: true
    };
  },
  created() {
    if (this.$route.query.sendOrderId) {
      this.sendOrderId = this.$route.query.sendOrderId;
      this.pageType = this.$route.query.type ? this.$route.query.type : 1;
    }
    this.queryData();
  },
  mounted() {},
  methods: {
    queryData() {
      var queryParams = {
        sendOrderId: this.sendOrderId
      };
      axiosApi
        .querySendOrder(queryParams)
        .then(response => {
          var data = response.content;
          data.imgList = [];
          if (data.productSkuList && data.productSkuList.length > 0) {
            data.productSkuList.forEach(item => {
              if (item.imgUrl) {
                data.imgList.push(item.imgUrl);
              }
            });
          }
          // data.confirmFile = response.content.confirmFile?response.content.confirmFile:[]
          if (data.qualityOrderType == 1) {
            data.qualityOrderTypeStr = "抽检";
          } else if (data.qualityOrderType == 2) {
            data.qualityOrderTypeStr = "全检";
          } else if (data.qualityOrderType == 3) {
            data.qualityOrderTypeStr = "免检";
          }
          if (!data.reciveTotalCtn) {
            data.reciveTotalCtn = data.sendTotalCtn;
          }
          for (var ind in data) {
            var val = data[ind] != null ? data[ind] : "";
            this.$set(this.basicForm, ind, val);
          }
          if (data.confirmFile && data.confirmFile.length > 0) {
            data.confirmFile.forEach(item => {
              this.fileList.push({ url: item });
            });
          }
          var channelStr = "";
          if (this.basicForm.firstDeptName) {
            channelStr += this.basicForm.firstDeptName;
          }
          if (this.basicForm.secondDeptName) {
            channelStr += "/" + this.basicForm.secondDeptName;
          }
          this.$set(this.basicForm, "channelStr", channelStr);
          if (data.sendOrderStatus != 1 && this.pageType == 1) {
            Toast.fail("该送货单无需仓库签收");
          }
        })
        .catch(error => {});
    },
    preview(index) {
      // var imageList = [];
      // this.basicForm.productSkuList.forEach((item)=>{
      //   if(item.imgUrl){
      //     imageList.push(item.imgUrl)
      //   }
      // })
      ImagePreview({
        images: this.basicForm.imgList,
        startPosition: index
      });
    },
    delImg(file, detail) {
      return new Promise((resolve, reject) => {
        this.basicForm.confirmFile.splice(detail.index, 1);
        var queryParams = {
          sendOrderId: this.sendOrderId,
          confirmFile: this.basicForm.confirmFile
        };
        axiosApi
          .updateSendOrder(queryParams)
          .then(response => {
            resolve();
          })
          .catch(error => {});
      });
    },
    afterRead(file) {
      this.canSubmit = false;
      // console.log(file)
      // console.log(this.fileList)
      if (Array.isArray(file)) {
        for (var i in file) {
          uploadFile(file[i].file, "file", url => {
            // this.basicForm.confirmFileStr = url.slice(url.lastIndexOf('/'))
            this.basicForm.confirmFile.push(url);
            if (i == file.length - 1) {
              var queryParams = {
                sendOrderId: this.sendOrderId,
                confirmFile: this.basicForm.confirmFile
              };
              axiosApi
                .updateSendOrder(queryParams)
                .then(response => {
                  this.canSubmit = true;
                })
                .catch(error => {});
            }
          });
        }
      } else {
        uploadFile(file.file, "file", url => {
          // this.basicForm.confirmFileStr = url.slice(url.lastIndexOf('/'))
          this.basicForm.confirmFile.push(url);
          var queryParams = {
            sendOrderId: this.sendOrderId,
            confirmFile: this.basicForm.confirmFile
          };
          axiosApi
            .updateSendOrder(queryParams)
            .then(response => {
              this.canSubmit = true;
            })
            .catch(error => {});
        });
      }
      // file.status = 'uploading';
      // file.message = '上传中...';
      //
      // setTimeout(() => {
      //   file.status = 'failed';
      //   file.message = '上传失败';
      // }, 1000);
    },
    toMore() {
      this.$router.push({ name: "sendOrderDetailMore" });
    },
    toBase() {
      this.$router.push({ name: "sendOrderDetailBase" });
    },
    onSubmit(type) {
      if (this.canSubmit && this.pageType == 1) {
        var params = {
          sendOrderStatus: 2,
          sendOrderId: this.sendOrderId,
          orderPosition: this.basicForm.orderPosition,
          confirmFile: this.basicForm.confirmFile,
          reciveTotalCtn: this.basicForm.reciveTotalCtn
        };
        axiosApi
          .receiveSendOrder(params)
          .then(response => {
            Toast.success("操作成功");
            this.$router.back(-1);
          })
          .catch(error => {});
      }
      if (this.pageType != 1) {
        Toast.success("保存成功");
        this.$router.back(-1);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/sendOrder/warehouseGet.vue